/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthedImport } from './routes/_authed'
import { Route as SignupIndexImport } from './routes/signup/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as ForgotPasswordIndexImport } from './routes/forgot-password/index'
import { Route as AuthedIndexImport } from './routes/_authed/index'
import { Route as ResetPasswordTokenImport } from './routes/reset-password/$token'
import { Route as VerifyEmailVerifyemailtokenIndexImport } from './routes/verify-email/$verify_email_token/index'
import { Route as InviteInvitetokenIndexImport } from './routes/invite/$invite_token/index'
import { Route as ChangeEmailChangeemailtokenIndexImport } from './routes/change-email/$change_email_token/index'
import { Route as AuthedClientcodeIndexImport } from './routes/_authed/$client_code/index'
import { Route as InviteInvitetokenCurrentIndexImport } from './routes/invite/$invite_token/current/index'
import { Route as AuthedClientcodeSettingsIndexImport } from './routes/_authed/$client_code/settings/index'
import { Route as AuthedClientcodePlaygroundIndexImport } from './routes/_authed/$client_code/playground/index'
import { Route as AuthedClientcodeMarketsIndexImport } from './routes/_authed/$client_code/markets/index'
import { Route as AuthedClientcodeSettingsUsersIndexImport } from './routes/_authed/$client_code/settings/users/index'
import { Route as AuthedClientcodeSettingsInvitationsIndexImport } from './routes/_authed/$client_code/settings/invitations/index'
import { Route as AuthedClientcodeSettingsApikeysIndexImport } from './routes/_authed/$client_code/settings/apikeys/index'
import { Route as AuthedClientcodePlaygroundIconsIndexImport } from './routes/_authed/$client_code/playground/icons/index'
import { Route as AuthedClientcodePlaygroundFormsIndexImport } from './routes/_authed/$client_code/playground/forms/index'
import { Route as AuthedClientcodePlaygroundComponentsIndexImport } from './routes/_authed/$client_code/playground/components/index'
import { Route as AuthedClientcodePlaygroundColoursIndexImport } from './routes/_authed/$client_code/playground/colours/index'
import { Route as AuthedClientcodeMarketsCreateIndexImport } from './routes/_authed/$client_code/markets/create/index'
import { Route as AuthedClientcodeMarketsMarketcodeIndexImport } from './routes/_authed/$client_code/markets/$market_code/index'
import { Route as AuthedClientcodeMarketsMarketcodeOrdersIndexImport } from './routes/_authed/$client_code/markets/$market_code/orders/index'
import { Route as AuthedClientcodeMarketsMarketcodeInstrumentsIndexImport } from './routes/_authed/$client_code/markets/$market_code/instruments/index'
import { Route as AuthedClientcodeMarketsMarketcodeConnectionsIndexImport } from './routes/_authed/$client_code/markets/$market_code/connections/index'
import { Route as AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolIndexImport } from './routes/_authed/$client_code/markets/$market_code/instruments/$instrument_symbol/index'
import { Route as AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolOrdersIndexImport } from './routes/_authed/$client_code/markets/$market_code/instruments/$instrument_symbol/orders/index'
import { Route as AuthedClientcodeMarketsMarketcodeConnectionsItchConnectionidIndexImport } from './routes/_authed/$client_code/markets/$market_code/connections/itch.$connection_id/index'
import { Route as AuthedClientcodeMarketsMarketcodeConnectionsFixSessionidIndexImport } from './routes/_authed/$client_code/markets/$market_code/connections/fix.$session_id/index'

// Create/Update Routes

const AuthedRoute = AuthedImport.update({
  id: '/_authed',
  getParentRoute: () => rootRoute,
} as any)

const SignupIndexRoute = SignupIndexImport.update({
  path: '/signup/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordIndexRoute = ForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const AuthedIndexRoute = AuthedIndexImport.update({
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)

const ResetPasswordTokenRoute = ResetPasswordTokenImport.update({
  path: '/reset-password/$token',
  getParentRoute: () => rootRoute,
} as any)

const VerifyEmailVerifyemailtokenIndexRoute =
  VerifyEmailVerifyemailtokenIndexImport.update({
    path: '/verify-email/$verify_email_token/',
    getParentRoute: () => rootRoute,
  } as any)

const InviteInvitetokenIndexRoute = InviteInvitetokenIndexImport.update({
  path: '/invite/$invite_token/',
  getParentRoute: () => rootRoute,
} as any)

const ChangeEmailChangeemailtokenIndexRoute =
  ChangeEmailChangeemailtokenIndexImport.update({
    path: '/change-email/$change_email_token/',
    getParentRoute: () => rootRoute,
  } as any)

const AuthedClientcodeIndexRoute = AuthedClientcodeIndexImport.update({
  path: '/$client_code/',
  getParentRoute: () => AuthedRoute,
} as any)

const InviteInvitetokenCurrentIndexRoute =
  InviteInvitetokenCurrentIndexImport.update({
    path: '/invite/$invite_token/current/',
    getParentRoute: () => rootRoute,
  } as any)

const AuthedClientcodeSettingsIndexRoute =
  AuthedClientcodeSettingsIndexImport.update({
    path: '/$client_code/settings/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodePlaygroundIndexRoute =
  AuthedClientcodePlaygroundIndexImport.update({
    path: '/$client_code/playground/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsIndexRoute =
  AuthedClientcodeMarketsIndexImport.update({
    path: '/$client_code/markets/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeSettingsUsersIndexRoute =
  AuthedClientcodeSettingsUsersIndexImport.update({
    path: '/$client_code/settings/users/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeSettingsInvitationsIndexRoute =
  AuthedClientcodeSettingsInvitationsIndexImport.update({
    path: '/$client_code/settings/invitations/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeSettingsApikeysIndexRoute =
  AuthedClientcodeSettingsApikeysIndexImport.update({
    path: '/$client_code/settings/apikeys/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodePlaygroundIconsIndexRoute =
  AuthedClientcodePlaygroundIconsIndexImport.update({
    path: '/$client_code/playground/icons/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodePlaygroundFormsIndexRoute =
  AuthedClientcodePlaygroundFormsIndexImport.update({
    path: '/$client_code/playground/forms/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodePlaygroundComponentsIndexRoute =
  AuthedClientcodePlaygroundComponentsIndexImport.update({
    path: '/$client_code/playground/components/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodePlaygroundColoursIndexRoute =
  AuthedClientcodePlaygroundColoursIndexImport.update({
    path: '/$client_code/playground/colours/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsCreateIndexRoute =
  AuthedClientcodeMarketsCreateIndexImport.update({
    path: '/$client_code/markets/create/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsMarketcodeIndexRoute =
  AuthedClientcodeMarketsMarketcodeIndexImport.update({
    path: '/$client_code/markets/$market_code/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsMarketcodeOrdersIndexRoute =
  AuthedClientcodeMarketsMarketcodeOrdersIndexImport.update({
    path: '/$client_code/markets/$market_code/orders/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsMarketcodeInstrumentsIndexRoute =
  AuthedClientcodeMarketsMarketcodeInstrumentsIndexImport.update({
    path: '/$client_code/markets/$market_code/instruments/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsMarketcodeConnectionsIndexRoute =
  AuthedClientcodeMarketsMarketcodeConnectionsIndexImport.update({
    path: '/$client_code/markets/$market_code/connections/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolIndexRoute =
  AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolIndexImport.update(
    {
      path: '/$client_code/markets/$market_code/instruments/$instrument_symbol/',
      getParentRoute: () => AuthedRoute,
    } as any,
  )

const AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolOrdersIndexRoute =
  AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolOrdersIndexImport.update(
    {
      path: '/$client_code/markets/$market_code/instruments/$instrument_symbol/orders/',
      getParentRoute: () => AuthedRoute,
    } as any,
  )

const AuthedClientcodeMarketsMarketcodeConnectionsItchConnectionidIndexRoute =
  AuthedClientcodeMarketsMarketcodeConnectionsItchConnectionidIndexImport.update(
    {
      path: '/$client_code/markets/$market_code/connections/itch/$connection_id/',
      getParentRoute: () => AuthedRoute,
    } as any,
  )

const AuthedClientcodeMarketsMarketcodeConnectionsFixSessionidIndexRoute =
  AuthedClientcodeMarketsMarketcodeConnectionsFixSessionidIndexImport.update({
    path: '/$client_code/markets/$market_code/connections/fix/$session_id/',
    getParentRoute: () => AuthedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      preLoaderRoute: typeof AuthedImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/$token': {
      preLoaderRoute: typeof ResetPasswordTokenImport
      parentRoute: typeof rootRoute
    }
    '/_authed/': {
      preLoaderRoute: typeof AuthedIndexImport
      parentRoute: typeof AuthedImport
    }
    '/forgot-password/': {
      preLoaderRoute: typeof ForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/signup/': {
      preLoaderRoute: typeof SignupIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authed/$client_code/': {
      preLoaderRoute: typeof AuthedClientcodeIndexImport
      parentRoute: typeof AuthedImport
    }
    '/change-email/$change_email_token/': {
      preLoaderRoute: typeof ChangeEmailChangeemailtokenIndexImport
      parentRoute: typeof rootRoute
    }
    '/invite/$invite_token/': {
      preLoaderRoute: typeof InviteInvitetokenIndexImport
      parentRoute: typeof rootRoute
    }
    '/verify-email/$verify_email_token/': {
      preLoaderRoute: typeof VerifyEmailVerifyemailtokenIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authed/$client_code/markets/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/playground/': {
      preLoaderRoute: typeof AuthedClientcodePlaygroundIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/settings/': {
      preLoaderRoute: typeof AuthedClientcodeSettingsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/invite/$invite_token/current/': {
      preLoaderRoute: typeof InviteInvitetokenCurrentIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authed/$client_code/markets/$market_code/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/create/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsCreateIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/playground/colours/': {
      preLoaderRoute: typeof AuthedClientcodePlaygroundColoursIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/playground/components/': {
      preLoaderRoute: typeof AuthedClientcodePlaygroundComponentsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/playground/forms/': {
      preLoaderRoute: typeof AuthedClientcodePlaygroundFormsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/playground/icons/': {
      preLoaderRoute: typeof AuthedClientcodePlaygroundIconsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/settings/apikeys/': {
      preLoaderRoute: typeof AuthedClientcodeSettingsApikeysIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/settings/invitations/': {
      preLoaderRoute: typeof AuthedClientcodeSettingsInvitationsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/settings/users/': {
      preLoaderRoute: typeof AuthedClientcodeSettingsUsersIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/connections/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeConnectionsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/instruments/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeInstrumentsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/orders/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeOrdersIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/instruments/$instrument_symbol/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/connections/fix/$session_id/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeConnectionsFixSessionidIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/connections/itch/$connection_id/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeConnectionsItchConnectionidIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/$client_code/markets/$market_code/instruments/$instrument_symbol/orders/': {
      preLoaderRoute: typeof AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolOrdersIndexImport
      parentRoute: typeof AuthedImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  AuthedRoute.addChildren([
    AuthedIndexRoute,
    AuthedClientcodeIndexRoute,
    AuthedClientcodeMarketsIndexRoute,
    AuthedClientcodePlaygroundIndexRoute,
    AuthedClientcodeSettingsIndexRoute,
    AuthedClientcodeMarketsMarketcodeIndexRoute,
    AuthedClientcodeMarketsCreateIndexRoute,
    AuthedClientcodePlaygroundColoursIndexRoute,
    AuthedClientcodePlaygroundComponentsIndexRoute,
    AuthedClientcodePlaygroundFormsIndexRoute,
    AuthedClientcodePlaygroundIconsIndexRoute,
    AuthedClientcodeSettingsApikeysIndexRoute,
    AuthedClientcodeSettingsInvitationsIndexRoute,
    AuthedClientcodeSettingsUsersIndexRoute,
    AuthedClientcodeMarketsMarketcodeConnectionsIndexRoute,
    AuthedClientcodeMarketsMarketcodeInstrumentsIndexRoute,
    AuthedClientcodeMarketsMarketcodeOrdersIndexRoute,
    AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolIndexRoute,
    AuthedClientcodeMarketsMarketcodeConnectionsFixSessionidIndexRoute,
    AuthedClientcodeMarketsMarketcodeConnectionsItchConnectionidIndexRoute,
    AuthedClientcodeMarketsMarketcodeInstrumentsInstrumentsymbolOrdersIndexRoute,
  ]),
  ResetPasswordTokenRoute,
  ForgotPasswordIndexRoute,
  LoginIndexRoute,
  SignupIndexRoute,
  ChangeEmailChangeemailtokenIndexRoute,
  InviteInvitetokenIndexRoute,
  VerifyEmailVerifyemailtokenIndexRoute,
  InviteInvitetokenCurrentIndexRoute,
])

/* prettier-ignore-end */
